/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { Component, Injector } from '@angular/core';
import { DetailAbstract, UNPLACEHOLDER } from '@dm/core';
import { SWITCH } from 'app/config';
import { type Observable, of } from 'rxjs';

import { type CheckDetail, CheckResult } from '../upgrade.const';
import { UpgradeStrService } from '../upgrade-str.service';

@Component({
    selector: 'app-detail-check-result-upgrade',
    templateUrl: './detail-check-result-upgrade.component.html',
    styleUrls: ['./detail-check-result-upgrade.component.scss'],
})
export class DetailCheckResultUpgradeComponent extends DetailAbstract<CheckDetail> {
    i18n = this.str.i18n;
    UNPLACEHOLDER = UNPLACEHOLDER;
    CheckResult = CheckResult;
    SWITCH = SWITCH;

    constructor(
        injector: Injector,
        public str: UpgradeStrService,
    ) {
        super(injector);
    }

    initOperationBtns(): void {
    }

    /**
     * 获取文件系统
     */
    getData(): Observable<CheckDetail> {
        return of(this.data);
    }

    /**
     * 外部数据更新事件
     * @param data 文件系统
     * @param isPollingUpdate 是否是表格轮询刷新触发的
     */
    onDataUpdate(data: any, isPollingUpdate: boolean): void {
        this.updateData(!isPollingUpdate);
    }
}
